import {
  each,
  eachL,
  equals2,
  filterL,
  go,
  isNil,
  mapL,
  rejectL,
  takeAll,
} from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
export const exportEditor = async (
  self,
  {
    factor,
    container_el,
    deepCloneNode = (node) => CommonNS.UtilNS.deepCloneNode(node),
  }
) => {
  const layers_el = self._getLayersElThrowable();
  const background_layer_el = self._getBackgroundLayerElThrowable();
  const target_image_layer_el = self._getTargetImageLayerElThrowable();
  const clip_path_layer_el = self._getClipPathLayerElThrowable();
  const art_board = self._getArtBoardThrowable();
  const view_box_width = art_board.getWidth();
  const view_box_height = art_board.getHeight();
  const view_port_width = view_box_width * factor;
  const view_port_height = view_box_height * factor;
  const clone_layers_el = layers_el.cloneNode(false);
  clone_layers_el.setAttributeNS(null, "width", `${view_port_width}`);
  clone_layers_el.setAttributeNS(null, "height", `${view_port_height}`);
  clone_layers_el.setAttributeNS(
    null,
    "viewBox",
    `0 0 ${view_box_width} ${view_box_height}`
  );
  const clone_background_layer_el = await deepCloneNode(background_layer_el);
  clone_layers_el.appendChild(clone_background_layer_el);
  const clone_target_image_layer_el = target_image_layer_el.cloneNode(false);
  const _clip_path_value = clone_target_image_layer_el.getAttributeNS(
    null,
    "clip-path"
  );
  if (_clip_path_value == null) {
    throw new Error("clip-path 대상을 찾을 수 없습니다.");
  }
  const clip_path_value = _clip_path_value;
  clone_target_image_layer_el.removeAttributeNS(null, "clip-path");
  clone_layers_el.appendChild(clone_target_image_layer_el);
  const clone_grids = await go(
    self._grids.values(),
    rejectL(({ target_image_el }) => isNil(target_image_el)),
    mapL(({ target_image_el, dummy_g_el }) =>
      go(target_image_el, deepCloneNode, (target_image_el) => ({
        target_image_el,
        dummy_g_el,
      }))
    ),
    mapL(({ target_image_el, dummy_g_el }) => {
      go(
        target_image_el.children,
        filterL((el) => {
          const cloned_role = el?.dataset?.[CommonNS.ConstNS.DATA_KEY_ROLE];
          const role = dummy_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE];
          return cloned_role && role && equals2(cloned_role)(role);
        }),
        takeAll,
        eachL((el) => target_image_el.removeChild(el)),
        takeAll
      );
      const clone_dummy_g_el = dummy_g_el.cloneNode(false);
      target_image_el.appendChild(clone_dummy_g_el);
      return {
        target_image_el,
        dummy_g_el: clone_dummy_g_el,
      };
    }),
    mapL(async ({ target_image_el, dummy_g_el }) => {
      const stroke = new StrokeNS.ModelNS.Stroke({
        svg_el: self._svg_el,
        getCTM: () => {
          const dummy_g_el_ctm = dummy_g_el.getCTM();
          if (dummy_g_el_ctm == null) {
            throw new Error(`해당 이미지의 CTM 을 구할 수 없습니다.`);
          }
          const target_image_layer_el_ctm =
            clone_target_image_layer_el.getCTM();
          if (target_image_layer_el_ctm == null) {
            throw new Error(`해당 이미지의 CTM 을 구할 수 없습니다.`);
          }
          return target_image_layer_el_ctm.multiply(dummy_g_el_ctm);
        },
      });
      const stroke_sync = new StrokeNS.ModelNS.StrokeSync({
        el: target_image_el,
        SVGGraphicsElement: self._window.SVGGraphicsElement,
        stroke,
      });
      return {
        target_image_el,
        dummy_g_el,
        stroke_sync,
      };
    }),
    eachL(({ target_image_el }) =>
      clone_target_image_layer_el.appendChild(target_image_el)
    ),
    takeAll
  );
  container_el.appendChild(clone_layers_el);
  each(({ stroke_sync }) => stroke_sync.sync())(clone_grids);
  container_el.removeChild(clone_layers_el);
  each(({ target_image_el, dummy_g_el }) =>
    target_image_el.removeChild(dummy_g_el)
  )(clone_grids);
  const clone_clip_path_layer_el = await deepCloneNode(clip_path_layer_el);
  clone_layers_el.appendChild(clone_clip_path_layer_el);
  clone_target_image_layer_el.setAttributeNS(
    null,
    "clip-path",
    clip_path_value
  );
  return clone_layers_el;
};
